module.exports = __webpack_public_path__ + "img/17463456001324.2ec54313.png";